export default "__VITE_ASSET__ClCgj9Ir__"